export const works = [
    {
        "id":1,
        "projectName":"Moonducks",
        "description": "Moonducks is the redesigned version of the official website of Starbucks India.",
        "dribbbleLink":"https://dribbble.com/shots/18586458-MoonDucks",
        "codepenLink":"https://codepen.io/overReacting/full/yLKBvMa",
    },
    {
        "id":2,
        "projectName":"Leaflet",
        "description": "Leaflet is a website to buy exotic plants online.",
        "dribbbleLink":"https://dribbble.com/shots/18675323-Leaflet-For-everything-planty",
        "codepenLink":"https://codepen.io/overReacting/full/YzayEwa",
    }
];